import { IAlert } from 'src/interfaces/props'
import { useEffect, useState } from 'react'

function AlertMessage({ type, text }: IAlert) {
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false)
    }, 5000)
    return () => clearTimeout(timer)
  }, [])
  return <>{visible && <p className={`alert-message ${type}`}>{text}</p>}</>
}

export default AlertMessage
